import React               from "react";
//import { UserContext }           from '../../../contexts/user';

import AppBar              from '@mui/material/AppBar';
import Box                 from '@mui/material/Box';
import Toolbar             from '@mui/material/Toolbar';
import Typography          from '@mui/material/Typography';
import Container           from '@mui/material/Container';
//import Button              from '@mui/material/Button';


import LoginUser           from './loginUser';
import MobileViewMenu      from './mobileViewMenu';
import Logo                from '../assets/images/overseasEduLogo.png';

export default function ResponsiveAppBar () {
	return (
		<AppBar position="static" style={{backgroundColor: 'white'}}>
			<Container maxWidth="xl">
				<Toolbar disableGutters>
					<Box
						sx={{ display: { xs: 'none', md: 'flex'}, mr: 1, ml: '20px' }} 
						component="img"
						alt="The house from the offer."
						src={Logo}
						style={{width: '55px'}}
					/>
					<Typography
						noWrap
						component="a"
						href="/"
						sx={{
							mr: 2,
							display: { xs: 'none', md: 'flex' },
							fontWeight: 'bold',
							fontSize: 'large',
							color: 'black',
							textDecoration: 'none',
						}}
					>
						<span className="font">Overseas.one</span>
					</Typography>
					<MobileViewMenu />
					<LoginUser />
				</Toolbar>
			</Container>
		</AppBar>
	);
}
